const gridProfile = {
  gridProfile: {
    pageHeader: 'Perfil de red',
    name: 'Nombre',
    description: 'Descripción',
    createdBy: 'Creado por',
    noGrid: '** Sin Redes disponibles **',
    grids: 'Redes'
  }
};

export default gridProfile;
